import {FC} from 'react'
import SVG from 'react-inlinesvg'
import {useHistory} from 'react-router-dom'
import {fleurSVGBlack} from '../../utils/constants'

/**
 * Confirmacion del pago (Figma 4457:77143).
 *
 * Reusa las clases `tap-add-experience-success-*` y el ornamento de flor de lis que ya usan las
 * otras pantallas de exito (introductions, experiences): su tipografia coincide con el diseno
 * —Oswald 500/40 y Satoshi 300/14— asi que no habia nada nuevo que definir.
 */
const ExpertisePaymentSuccessPage: FC = () => {
  const history = useHistory()

  return (
    <div className='tap-flex-center expertise-payment-success'>
      <div className='tap-add-experience-success-container' style={{maxWidth: '550px'}}>
        <div className='tap-add-experience-success-title'>Thank you</div>

        <div className='tap-add-experience-success-subtitle'>
          Your payment was processed successfully. The Expert has been notified and you can arrange
          the details of your session directly in the messenger.
        </div>

        <div className='tap-add-experience-success-icon-wrapper'>
          <div className='line-svg'>
            <SVG src={'/media/svg/nobilis/teams_and_partner/mask-success-line-icon.svg'} />
          </div>
          <div className='icon-svg'>
            <SVG src={fleurSVGBlack} />
          </div>
          <div className='line-svg'>
            <SVG src={'/media/svg/nobilis/teams_and_partner/mask-success-line-icon.svg'} />
          </div>
        </div>

        <div className='w-100 tap-flex-center'>
          <div
            className='tap-add-experience-success-btn-secondary cursor-pointer'
            onClick={() => history.push('/messages')}
          >
            <div>go to messenger</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {ExpertisePaymentSuccessPage}
export default ExpertisePaymentSuccessPage
